<template>
  <div>
    <UserLikesButton :likes="likes"
                     :on-click="openModal"
                     :show-label="itemType === 'Post'"
    />
    <modal @close="closeModal"
           class="modal"
           v-if="showModal"
           :width="'450px'"
    >
      <div slot="header">
        {{ $t('shared.userLikes.title') }}
      </div>
      <UserLikes slot="body" :user-likes="userLikes(idItem)" />
    </modal>
  </div>
</template>
<script>
import Modal from '../shared/Modal'
import UserLikesButton from './UserLikesButton'
import UserLikes from './UserLikes'

export default {
  name: 'UserLikesModal',
  components: { UserLikes, Modal, UserLikesButton },
  props: {
    likes: {
      // { type, idUser }
      type: Array,
      default: () => []
    },
    idItem: {
      type: String,
      required: true
    },
    itemType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    async openModal() {
      await this.$store.dispatch('fetchUserLikes', { idItem: this.idItem, itemType: this.itemType })
      this.showModal = true
    },
    userLikes(idItem) {
      return this.$store.getters.userLikes(idItem)
    }
  }
}
</script>
